export const de_DE_bvReactClientDefaultConfig = {
  apiUrl: 'https://api.bonavendi.de',
  country: 'de',
  userSells: true,
  nextJs: {
    productCategoryUrls:
      'd6b13526-498f-4f1f-a39e-f265637365b8=>/verkaufen/handys/apple,0e829edb-1157-4795-be5e-a648a919c7ed=>/verkaufen/handys/apple',
  },
  transactions: {
    enabled: true,
    url: 'https://www.bonavendi.de/verkaufen/verkaeufe.html',
    forwardUrl:
      'https://www.bonavendi.de/verkaufen/weiterleitung-zum-partner.html',
  },
  priceQuery: {
    preselectedCategoryUuid: '64f6cfe0-3f10-4abd-8ba2-8c020da0e7d1',
    searchFieldPreFillText: null,
    url: 'https://www.bonavendi.de/verkaufen/gebraucht.html',
  },

  userProfile: {
    url: 'https://www.bonavendi.de/verkaufen/profil.html',
  },
  cart: {
    url: 'https://www.bonavendi.de/verkaufen/korb.html',
  },
  massInput: {
    url: 'https://www.bonavendi.de/verkaufen/sammeleingabe.html',
  },
  errorPages: {
    countryBlockedUrl: 'https://www.bonavendi.de/unsupportedCountry.html',
    ipBlockedUrl: 'https://www.bonavendi.de/apiAbuse.html',
    tooManyPricequeries: 'https://www.bonavendi.de/tooManyPricequeries.html',
  },
};
